/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import fn from '../../helpers/fn';

const svgLogo = `
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1024 1024">
    <defs>
      <style>.a{fill:url(#a);}.b{fill:#fff;}</style>
      <linearGradient id="a" x1="68.08" y1="955.92" x2="955.92" y2="68.08" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#ffa119"/>
        <stop offset="1" stop-color="#333"/>
      </linearGradient>
      <symbol id="c" viewBox="0 0 573.48 575.25">
        <path
          class="b"
          d="M108.72,85.87C65.24,44.41,52.22,38.31,50,37.5L64,0c8.9,3.29,26.11,12.79,72.48,57,24.43,23.3,45.17,45,46,45.91l-28.94,27.62C153.33,130.34,132.49,108.54,108.72,85.87Z"
        />
        <path
          class="b"
          d="M452.63,187.93q-12.21-5.12-23.58-10.8,39.73-25.29,64.27-53.35c40.6-46.51,34.59-82.62,33.76-86.58l-3.29-16H226.5v40h39.61c13.44,37.62,36.17,71.12,67.73,99.74q7.62,6.91,15.92,13.44C299.42,197.79,243.61,215.89,196.18,229l10.64,38.56q108.32-29.86,181.25-67.12a411.88,411.88,0,0,0,49.09,24.41c68.42,28.7,129.78,35.07,132.36,35.33l4-39.8C572.91,220.29,515.58,214.34,452.63,187.93Zm-91.92-56.57c-22.74-20.62-40-44.12-51.55-70.11h176.1c-3.31,10.1-10.64,24.32-26.64,41.24-18,19-41.93,36.21-69,51.57A269.68,269.68,0,0,1,360.71,131.36Z"
        />
        <polygon
          class="b"
          points="406.5 427.25 567.5 427.25 567.5 467.25 406.5 467.25 406.5 575.25 366.5 575.25 366.5 467.25 218.5 467.25 218.5 427.25 366.5 427.25 366.5 352.25 247.5 352.25 247.5 312.25 366.5 312.25 366.5 255.25 406.5 255.25 406.5 312.25 536.5 312.25 536.5 352.25 406.5 352.25 406.5 427.25"
        />
        <path
          class="b"
          d="M167.23,428.92l37.56,13.67a36.18,36.18,0,0,1-4.42,8.65c-15.29,22-88.65,82.56-103.2,94.48L71.83,514.78c6.35-5.2,13.58-11.21,21.17-17.6V230.75H0v-40H133V462.5c16.61-14.87,30.24-27.93,34.52-34.09A4.82,4.82,0,0,0,167.23,428.92Z"
        />
      </symbol>
      <symbol id="b" viewBox="0 0 1024 1024">
        <path
          class="a"
          d="M357,0H667C769.8,0,821.18,0,876.52,17.49a217.46,217.46,0,0,1,130,130C1024,202.83,1024,254.22,1024,357V667c0,102.8,0,154.19-17.5,209.53a217.43,217.43,0,0,1-130,130C821.18,1024,769.8,1024,667,1024H357c-102.79,0-154.18,0-209.51-17.5a217.43,217.43,0,0,1-130-130C0,821.18,0,769.79,0,667V357C0,254.22,0,202.83,17.5,147.48a217.46,217.46,0,0,1,130-130C202.82,0,254.2,0,357,0h0"
        />
        <use width="573.48" height="575.25" transform="translate(218 241.25)" xlink:href="#c" />
      </symbol>
    </defs>
    <title>SpaceTranslate</title>
    <use width="1024" height="1024" xlink:href="#b"/>
  </svg>
`;

const svgEncode = svgString => `data:image/svg+xml,${svgString
  .replace(/\n/g, '')
  .replace(/</g, '%3C')
  .replace(/>/g, '%3E')
  .replace(/"/g, '\'')
  .replace(/#/g, '%23')
  .replace(/&/g, '%26')
}`;

export default fn(__filename, styled.i`
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("${svgEncode(svgLogo)}");
  border: 0;
  display: inline-block;
  height: 57px;
  width: 57px;

  ${({ large }) => large && `
    height: 192px;
    width: 192px;
  `}
`.withComponent(({
  large, // strip
  ...props
}) => <i {...props} />));



// WEBPACK FOOTER //
// ./src/components/icons/Logo.js